<template>
  <div class="title-secondary">
    <h3 :style="styling">
      <slot />
    </h3>
  </div>
</template>

<style lang="scss" scoped>
  @import '../../assets/styles.scss';
@import './title-style.scss';
</style>

<script>
export default {
  props: {
    align: {
      type: String,
      default: 'left'
    },
    styling: {
      type: Object
    }
  }
}
</script>
